exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stages-customer-and-levels{list-style:disc;padding-left:15px}.planned-stages-list .start-stage-summary-indicator{margin-top:-50px;padding-top:50px}.planned-stages-list .planned-stages-summary-title .media-content{overflow:hidden}.planned-stages-list .planned-stages-summary-title .icon{float:right;margin-top:5px}.planned-stages-list .planned-stages-summary-title.is-sticky-summary{position:sticky;bottom:7px;cursor:pointer;transition:box-shadow .1s}.planned-stages-list .planned-stages-summary-title.is-sticky-summary:hover{box-shadow:0 .5em 1.5em -.125em rgba(10,10,10,.25),0 0 0 1px rgba(10,10,10,.02)}", ""]);

// exports
